import React from 'react';
import PropTypes from 'prop-types';
import HardTokenChallengeLib from 'hard-token-challenge-lib';

import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import SecurityDeviceStore from '../../stores/SecurityDeviceStore';
import SessionStore from '../../stores/SessionStore';
import SessionActionCreator from '../../actions/SessionActionCreator';
import StepHeader from '../../includes/StepHeader';
import envConfig from '../../../static/config';
import api from '../../utils/Api';
import InternetBankingActions from '../../actions/InternetBankingActions';
import StringConstants from '../../constants/StringConstants';

const getBrand = (brandId) => {
  const brand = {
    CB: 'CB',
    YB: 'YB',
    DYB: 'B',
    VM: 'VM',
  };

  return brand[brandId.toUpperCase()];
};

class ActivationPage extends React.Component {
  constructor(props) {
    super(props);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.onSecurityDeviceStoreChange =
      this.onSecurityDeviceStoreChange.bind(this);

    this.state = {
      clientContext: api.clientContext(),
      accessToken: SessionStore.getToken().access_token,
      apiUrl: envConfig.apiBaseUrl,
      PAASUrl: envConfig.apiBaseUrlPAAS,
      bankId: SessionStore.getSessionBankID(),
      brand: getBrand(envConfig.brandId),
      securityDevice: SecurityDeviceStore.getOrderedSecurityDevice(),
    };
  }

  componentDidMount() {
    SecurityDeviceStore.addChangeListener(this.onSecurityDeviceStoreChange);
  }

  componentWillUnmount() {
    SecurityDeviceStore.removeChangeListener(this.onSecurityDeviceStoreChange);
  }

  onSecurityDeviceStoreChange() {
    this.setState({
      securityDevice: SecurityDeviceStore.getOrderedSecurityDevice(),
    });
  }

  handleBackButton() {
    InternetBankingActions.navigateToWebTask(StringConstants.WEB_HOMEPAGE);
  }

  handleFail() {
    SessionActionCreator.requestAccessTokenReset(true);
  }

  handleSuccess() {
    InternetBankingActions.navigateToWebTask(StringConstants.WEB_HOMEPAGE);
  }

  render() {
    const { ...config } = this.state;
    return (
      <div className="page bow">
        <div id="site-main" className="container" role="main" tabIndex="-1">
          <div className="row">
            <div className="col-md1-18">
              {
                <StepHeader
                  showheaderCrumbs
                  headerCrumbsMessage={'Back to accounts'}
                  headerTitle={'Activate your security token'}
                  onClick={this.handleBackButton}
                />
              }
            </div>
          </div>

          <div className="web-ui-components">
            <HardTokenChallengeLib
              config={{ ...config }}
              securityDevice={this.state.securityDevice}
              onFail={this.handleFail}
              onSuccess={this.handleSuccess}
              mode="activation"
            />
          </div>
        </div>
      </div>
    );
  }
}

ActivationPage.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(ActivationPage);
